import styled from 'styled-components';
import { tokens } from '@cellula/react-theme-patient';
import { ReactNode } from 'react';

interface Props {
	children: ReactNode;
}

const elements = {
	container: styled.div`
		width: 100%;
		padding: ${tokens.spacing.x3} ${tokens.spacing.x2};
		color: ${tokens.color.content.muted};
		border: 1px dashed ${tokens.color.border.default};
		border-radius: 12px;

		h2 {
			font: ${tokens.text.heading.xSmall};
		}

		p {
			font: ${tokens.text.body.smallRegular};
		}

		${tokens.breakpointQuery.medium} {
			text-align: center;

			h2 {
				font: ${tokens.text.heading.small};
			}

			p {
				font: ${tokens.text.body.regular};
			}
		}
	`,
};

export function EmptyState({ children }: Props): JSX.Element {
	return <elements.container>{children}</elements.container>;
}
